module.exports = __webpack_public_path__ + "static/media/logo-amapamaranhao.f4ffdb08.png";